export const IS_SANDBOX = process.env.REACT_APP_SANDBOX;
export const EXTENSION_IDENTIFIER =
  process.env.REACT_APP_EXTENSION_IDENTIFIER || "easyshopifyforzohocrm";
export const WIDGET_VERSION = process.env.REACT_APP_WIDGET_VERSION || "V1";

// Organization variable API names
export const ORG_VAR_MAPS_API_NAME =
  EXTENSION_IDENTIFIER + "__Organiztion_Var_Maps";
export const API_KEY_API_NAME = EXTENSION_IDENTIFIER + "__API_KEY";
export const DATA_CENTER_API_NAME = EXTENSION_IDENTIFIER + "__Data_Center";
export const DATA_CENTER_URL_API_NAME =
  EXTENSION_IDENTIFIER + "__Data_Center_URL";
export const LOG_ERRORS_API_NAME = EXTENSION_IDENTIFIER + "__Log_Errors";
export const ORG_ID_API_NAME = EXTENSION_IDENTIFIER + "__Organization_ID";
export const SHOPIFY_API_KEY_API_NAME =
  EXTENSION_IDENTIFIER + "__SHOPIFY_API_KEY";
export const Z_API_KEY_API_NAME = EXTENSION_IDENTIFIER + "__ZAPI_Key";
export const ZUID_API_NAME = EXTENSION_IDENTIFIER + "__ZUID";

// Connection names
export const ZOHO_CONN = EXTENSION_IDENTIFIER + "__zoho";

// Shopify connection name is per-store so each store has its own unique connection.
// Format: `${EXTENSION_IDENTIFIER}__shopify__${shopDomain}`
export const buildShopifyConnName = (shop) =>
  shop ? `${EXTENSION_IDENTIFIER}__shopify__${shop}` : "";

// Org-level Shopify connection name — used ONLY for the /auth/shopify/tokens
// route which lists every token under the org (no single shop context).
export const SHOPIFY_ORG_CONN = `${EXTENSION_IDENTIFIER}__shopify`;

// Header key used to identify which Shopify store an API call targets
export const SHOPIFY_SHOP_URL_HEADER_KEY = "shopifyshopurl";

// Build the value for the shopifyshopurl header — raw shop domain only
// (e.g. "rayhancloth.myshopify.com"). The EXTENSION_IDENTIFIER prefix
// belongs in the `connname` header, not here.
export const buildShopifyShopUrlHeader = (shop) => (shop ? shop : "");

// Server URLs
export const ADMIN_API_URL = process.env.REACT_APP_ADMIN_SERVER_URL;
export const SERVICE_API_URL = process.env.REACT_APP_API_SERVER_URL;

// Base path for Shopify OAuth (Partner Custom App + OAuth flow).
// Full URL: `${ADMIN_API_URL}${SHOPIFY_OAUTH_PATH}/<endpoint>`
export const SHOPIFY_OAUTH_PATH = "/auth/shopify/oauth2";

// All org variable keys for bulk fetch
export const ALL_ORG_VARIABLE_KEYS = [
  ORG_VAR_MAPS_API_NAME,
  API_KEY_API_NAME,
  DATA_CENTER_API_NAME,
  DATA_CENTER_URL_API_NAME,
  LOG_ERRORS_API_NAME,
  ORG_ID_API_NAME,
  SHOPIFY_API_KEY_API_NAME,
  Z_API_KEY_API_NAME,
  ZUID_API_NAME,
];
